var _rect, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgRepeat(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Repeat",
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_7388",
    "data-name": "Rectangle 7388",
    width: 24,
    height: 24,
    fill: "rgba(255,255,255,0)"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "repeat-svgrepo-com",
    d: "M6.6.623A10.1,10.1,0,0,1,16.978,2.708l1.06-1.061a1.262,1.262,0,0,1,2.154.892V7.572H15.16a1.262,1.262,0,0,1-.892-2.154l.923-.923a7.572,7.572,0,1,0,1.738,8.864,1.262,1.262,0,1,1,2.278,1.087A10.1,10.1,0,1,1,6.6.623Z",
    transform: "translate(1 2)",
    fill: "#1dbbbe"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRepeat);
export default __webpack_public_path__ + "static/media/Repeat.7f8dd642807fa24f2d47d4557efde1b0.svg";
export { ForwardRef as ReactComponent };